import React from "react"

import Index from "../index/index"
import "../styles/global.scss"
import { Container } from "@material-ui/core"

const IndexPage = () => (
  <Container>
    <Index />
  </Container>
)

export default IndexPage
